var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "addBOM",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c("div", [
              _c(
                "div",
                [
                  _c(
                    "b-form",
                    {
                      ref: "form",
                      staticClass: "repeater-form",
                      style: { height: _vm.trHeight },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.repeateAgain($event)
                        },
                        change: function ($event) {
                          return _vm.formChanged()
                        },
                      },
                    },
                    _vm._l(_vm.items, function (item, index) {
                      return _c(
                        "b-row",
                        {
                          key: item.serial,
                          ref: "form",
                          refInFor: true,
                          staticClass: "align-items-center",
                          attrs: { id: item.serial },
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Raw Material / Work In Progress",
                                    "label-for": "materialId",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "materialId",
                                      name: "materialId",
                                      options: _vm.itemOptions,
                                      "value-field": "id",
                                      "text-field": "name",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.itemChanged(item)
                                      },
                                    },
                                    model: {
                                      value: item.id,
                                      callback: function ($$v) {
                                        _vm.$set(item, "id", $$v)
                                      },
                                      expression: "item.id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Status",
                                    "label-for": "BOMstatus",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.BOMStatusList },
                                    on: {
                                      change: function ($event) {
                                        return _vm.callChangeStatus()
                                      },
                                    },
                                    model: {
                                      value: item.BOMstatus,
                                      callback: function ($$v) {
                                        _vm.$set(item, "BOMstatus", $$v)
                                      },
                                      expression: "item.BOMstatus",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Warehouse",
                                    "label-for": "Warehouse",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.optionsWarehouse },
                                    on: {
                                      change: function ($event) {
                                        return _vm.updateQtyAtHand(item)
                                      },
                                    },
                                    model: {
                                      value: item.wareHouseId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "wareHouseId", $$v)
                                      },
                                      expression: "item.wareHouseId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "1" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "UOM",
                                    "label-for": "materialUom",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    staticClass: "mr-3",
                                    attrs: {
                                      id: "materialUom",
                                      name: "materialUom",
                                      options: _vm.itemUoms,
                                      "value-field": "id",
                                      "text-field": "name",
                                      disabled: "",
                                    },
                                    model: {
                                      value: item.uom,
                                      callback: function ($$v) {
                                        _vm.$set(item, "uom", $$v)
                                      },
                                      expression: "item.uom",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "1" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Qty at hand",
                                    "label-for": "materialQty",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "mr-3",
                                    attrs: {
                                      id: "materialQty",
                                      name: "materialQty",
                                      type: "number",
                                      min: "1",
                                      disabled: "",
                                    },
                                    model: {
                                      value: item.physicalinventory,
                                      callback: function ($$v) {
                                        _vm.$set(item, "physicalinventory", $$v)
                                      },
                                      expression: "item.physicalinventory",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "1" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Qty Required",
                                    "label-for": "materialQty",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Qty Required",
                                      rules: "numeric|min_value:0",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "materialQty",
                                                  name: "materialQty",
                                                  type: "number",
                                                  min: "1",
                                                  max: "100",
                                                  placeholder: "",
                                                },
                                                on: {
                                                  keyup: function ($event) {
                                                    return _vm.itemqtyChanged(
                                                      item
                                                    )
                                                  },
                                                  input: function ($event) {
                                                    return _vm.validateQuantity(
                                                      item
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: item.quantity,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "quantity",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.quantity",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Total Cost (Rs)",
                                    "label-for": "materialCost",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "materialCost",
                                      name: "materialCost",
                                      value: "32$",
                                      disabled: "",
                                    },
                                    model: {
                                      value: item.totalCost,
                                      callback: function ($$v) {
                                        _vm.$set(item, "totalCost", $$v)
                                      },
                                      expression: "item.totalCost",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "1" } },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.focus.v-secondary",
                                      modifiers: {
                                        hover: true,
                                        focus: true,
                                        "v-secondary": true,
                                      },
                                    },
                                  ],
                                  attrs: {
                                    to: _vm.getUpdate(item.id),
                                    title:
                                      "View all Warehouses of the Raw Material",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-shrink" },
                                    [
                                      _c("feather-icon", {
                                        attrs: { icon: "BoxIcon" },
                                      }),
                                      _c("span", [
                                        _vm._v(_vm._s(item.stocklevel)),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "1" } },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(234, 84, 85, 0.15)",
                                      expression: "'rgba(234, 84, 85, 0.15)'",
                                      modifiers: { 400: true },
                                    },
                                  ],
                                  staticClass: "mr-3",
                                  attrs: { variant: "outline-danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeItem(index)
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "XIcon" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-0 d-flex align-items-center",
                              attrs: { md: "1" },
                            },
                            [
                              _c("b-form-checkbox", {
                                staticClass: "mb-0",
                                attrs: { value: item.itemId },
                                on: {
                                  change: function ($event) {
                                    return _vm.AddBOMPO(item)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      attrs: { variant: "primary" },
                      on: { click: _vm.addItem },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-25",
                        attrs: { icon: "PlusIcon" },
                      }),
                      _c("span", [_vm._v("Add Bill Of Materials")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }